/** Colore CSS risolto dal tema attivo, utile per librerie canvas come Chart.js. */
export function getDesignColor(token: string): string {
  if (typeof window === 'undefined') return 'transparent'
  return getComputedStyle(document.documentElement).getPropertyValue(`--color-${token}`).trim() || 'transparent'
}

/** Converte un token esadecimale in rgba per opacità non supportate dal consumer. */
export function getDesignColorWithAlpha(token: string, alpha: number): string {
  const color = getDesignColor(token)
  const hex = color.match(/^#([\da-f]{3}|[\da-f]{6})$/i)?.[1]
  if (!hex) return color

  const normalized = hex.length === 3 ? [...hex].map((part) => part + part).join('') : hex
  const [red, green, blue] = [0, 2, 4].map((offset) => Number.parseInt(normalized.slice(offset, offset + 2), 16))
  const opacity = Math.min(1, Math.max(0, alpha))
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`
}
